import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import Modal from 'react-bootstrap/Modal';

import Bolsa_unidade from "../Modulos/bolsa_unidade";

import Bolsas_pizza_detalhe from "./bolsa_pizza_detalhes";

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';


import { bolsas, bolsas_tipo, bolsas_tipo_novos, bolsas_tipo_renovados } from "../../services/api";

const Bolsas_pizza = (props) => {

    const [data2, setData2] = useState([]);
    const [data3, setData3] = useState([]);
    const [dataBN, setdataBN] = useState([]);
    const [dataBR, setdataBR] = useState([]);

    const [tiposelecionado, setTiposelecionado] = useState('');

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']


    let data_inicio = props.di;
    let data_fim = props.df;

    let row = '';

    const fetchData = async () => {
        try {
            const response = await bolsas(data_inicio, data_fim);
            setData2(response.data);
            const response3 = await bolsas_tipo(data_inicio, data_fim);
            console.log("----------------------------------", response3.data)
            setData3(response3.data);
            const response4 = await bolsas_tipo_novos(data_inicio, data_fim);
            setdataBN(response4.data);
            const response5 = await bolsas_tipo_renovados(data_inicio, data_fim);
            setdataBR(response5.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim, row]);

    let DataPizzaBolsa = []

    if (typeof data2 !== 'undefined') {
        const total = data2.reduce((acumulador, item) => {
            return acumulador + parseInt(item.alunos);
        }, 0);

        DataPizzaBolsa = data2.map((item, index) => {
            const row = [item.bolsas];
            row.push(item.alunos || 0);
            row.push((100 * parseInt(item.alunos)) / total);
            row.push(parseFloat(item.bolsa_media));
            return row;
        });
    };
    DataPizzaBolsa.unshift(["BOLSAS", "ALUNOS", "DIST%", "VLR MÉDIO"]);

    let DataBolsaNovos = []

    if (typeof dataBN !== 'undefined') {
        const total = dataBN.reduce((acumulador, item) => {
            return acumulador + parseInt(item.alunos);
        }, 0);

        DataBolsaNovos = dataBN.map((item, index) => {
            const row = [item.dsc];
            row.push(item.alunos || 0);
            row.push((100 * parseInt(item.alunos)) / total);
            row.push(parseFloat(item.vlr_medio));
            return row;
        });
    };
    DataBolsaNovos.unshift(["BOLSAS", "ALUNOS", "DIST%", "VLR MÉDIO"]);

    let DataBolsaReno = []

    if (typeof dataBR !== 'undefined') {
        const total = dataBR.reduce((acumulador, item) => {
            return acumulador + parseInt(item.alunos);
        }, 0);

        DataBolsaReno = dataBR.map((item, index) => {
            const row = [item.dsc];
            row.push(item.alunos || 0);
            row.push((100 * parseInt(item.alunos)) / total);
            row.push(parseFloat(item.vlr_medio));
            return row;
        });
    };
    DataBolsaReno.unshift(["BOLSAS", "ALUNOS", "DIST%", "VLR MÉDIO"]);


    const options = {
        allowHtml: true,

    };

    const formatters = [
        {
            type: "NumberFormat",
            column: 2,
            options: {
                suffix: "%",
            },
        },
        {
            type: "NumberFormat",
            column: 2,
            options: {
                suffix: "%",
            },
        },
        {
            type: "NumberFormat",
            column: 3,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 3,
            ranges: [
                [0, 25, "white", "green"],
                [25, 40, "white", "orange"],
                [40, 55, "white", "red"],
                [55, 100, "white", "darkred"],
            ],
        },
    ];



    if ((typeof DataPizzaBolsa !== 'undefined') && (typeof data2 !== 'undefined')) {
        return (
            <div className="bolsas">
                <Tabs
                    defaultActiveKey="Total"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                >
                    <Tab eventKey="Total" title="Total">
                        <h4>
                            Total de Bolsas Ativas
                        </h4>
                        <Chart
                            chartType="Table"
                            version="current"
                            width="100%"
                            data={DataPizzaBolsa}
                            options={options}
                            formatters={formatters}
                        />
                    </Tab>
                    <Tab eventKey="Novos" title=" Novas">
                        <h4>
                            Total de Bolsas Ativas
                        </h4>
                        <Chart
                            chartType="Table"
                            version="current"
                            width="100%"
                            data={DataBolsaNovos}
                            options={options}
                            formatters={formatters}
                        />
                    </Tab>
                    <Tab eventKey="Renovados" title=" Renovadas">
                        <h4>
                            Total de Bolsas Ativas
                        </h4>
                        <Chart
                            chartType="Table"
                            version="current"
                            width="100%"
                            data={DataBolsaReno}
                            options={options}
                            formatters={formatters}
                        />
                    </Tab>



                </Tabs>
            </div>
        );
    };
};
export default Bolsas_pizza;